import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import DatePickerField from "../../component/InputFieldLayout/datePicker";
import NumberField from "../../component/InputFieldLayout/numberField";
import { getRecipientMinistryStateAction } from "../../actions/mis.action";
import { MULTI_STATE_PROJECT, SELECT_MONITORING_OPTION } from "../../constant";
import {
  fetchProjectReport,
  fetchIssueSubCategories
} from "../../actions/mis.action";
import { parseInt, uniqBy } from "lodash";
import { getLocalstorage, setLocalstorage } from "../../helper";
import Select from "react-select";
import { components } from "react-select";
import { replaceCharacterWith } from "../../../src/helper";

class ProjectSummarySearchModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: this._getInitForm(),
      openModal: true,
      sponsoringMinistryList: [],
      inceptionDate: false,
      filtersList: [],
      appliedFilter: getLocalstorage("projectSummaryFilters") || [],
      previousFilterCount: 0,
      currentFilterCount: 0
    };
  }

  implementationModeTransformer = {
    PPP: "Private Public Partnership",
    PRIVATE: "Private",
    PUBLIC: "Public",
    NA: "NA"
  };

  _getInitForm = () => {
    return {
      projectCreatedFrom: "",
      projectCreatedTo: "",
      sponsoringMinistry: "",
      multiStateProject: "",
      implementationMode: "",
      projectLocation: "",
      projectScheme: "",
      projectStatus: "",
      projectCostTo: "",
      projectCostFrom: "",
      issueDistrict: "",
      selectedMonitoringId: ""
    };
  };

  componentDidMount() {
    const { getRecipientMinistryStateAction } = this.props;
    getRecipientMinistryStateAction().then(resp => {
      if (resp) {
        this.setState({
          sponsoringMinistryList: resp.data
        });
      }
    });
    const filter = getLocalstorage("projectSummaryFilters");
    if (filter && filter !== null) {
      this.setState({ previousFilterCount: filter.length });
      this.onOpeingOfModalAgain();
    }
  }

  onOpeingOfModalAgain = () => {
    const filter = getLocalstorage("projectSummaryFilters");
    if (filter && filter !== null) {
      const filters = getLocalstorage("projectSummaryFilters");
      const filterMap = {
        createdDate: "projectDateFilter",
        projectCost: "projectCostFilter",
        sponsoringMinistry: "sponsoringMinistry",
        implementationMode: "implementationMode",
        location: "projectLocation",
        projectScheme: "projectScheme",
        projectStatus: "projectStatus",
        districtDepartments: "issueDistrict",
        multiStateProject: "multiStateProject",
        monitoring: "selectedMonitoringId"
      };

      const filterObject = filters.reduce((result, filter) => {
        const filterKey = filterMap[filter.optionName];
        if (filterKey) {
          result[filterKey] = result[filterKey] || [];
          result[filterKey].push(filter);
        }
        return result;
      }, {});

      const {
        projectDateFilter,
        projectCostFilter,
        sponsoringMinistry,
        implementationMode,
        projectLocation,
        projectScheme,
        projectStatus,
        issueDistrict,
        multiStateProject,
        selectedMonitoringId
      } = filterObject;

      this.setState({
        projectCreatedFrom:
          projectDateFilter &&
          projectDateFilter.length !== 0 &&
          new Date(projectDateFilter[0].projectCreatedFrom),
        projectCreatedTo:
          projectDateFilter &&
          projectDateFilter.length !== 0 &&
          new Date(projectDateFilter[0].projectCreatedTo),
        projectCostFrom:
          projectCostFilter &&
          projectCostFilter.length !== 0 &&
          projectCostFilter[0].projectCostFrom,
        projectCostTo:
          projectCostFilter &&
          projectCostFilter.length !== 0 &&
          projectCostFilter[0].projectCostTo,
        sponsoringMinistry:
          sponsoringMinistry && sponsoringMinistry.map(item => item),
        implementationMode:
          implementationMode && implementationMode.map(item => item),
        projectLocation: projectLocation && projectLocation.map(item => item),
        projectScheme: projectScheme && projectScheme.map(item => item),
        projectStatus: projectStatus && projectStatus.map(item => item),
        issueDistrict: issueDistrict && issueDistrict.map(item => item),
        multiStateProject:
          multiStateProject && multiStateProject.map(item => item),
        selectedMonitoringId:
          selectedMonitoringId && selectedMonitoringId.map(item => item)
      });
    }
  };

  onSelectChange = (value, name) => {
    const update = {};
    update[name] = value;
    this.setState(update);
  };

  onProjectCraeatedDateChange = value => {
    value === null
      ? this.setState({ projectCreatedFrom: "" })
      : this.setState({ projectCreatedFrom: new Date(value) });
  };

  onProjectCraeatedFromDateChange = value => {
    value === null
      ? this.setState({ projectCreatedTo: "" })
      : this.setState({ projectCreatedTo: new Date(value) });
  };

  onInputChange = (event, name) => {
    this.setState({ [name]: event });
  };

  onClickOfCloseButton = () => {
    const { onOpenOfModal } = this.props;
    const { openModal } = this.state;
    this.setState({
      openModal: !openModal
    });
    onOpenOfModal(openModal);
  };
  onInceptionDateChecked = () => {
    const { inceptionDate } = this.state;
    if (inceptionDate) {
      this.setState({
        projectCreatedFrom: new Date(2013, 0, 1, 0, 0, 0, 0)
      });
    } else {
      this.setState({
        projectCreatedFrom: ""
      });
    }
  };

  validateFiltersOfProjectDates = () => {
    let { projectCreatedFrom, projectCreatedTo, filtersList } = this.state;
    let date = { type: "createdDate" };
    let filter = null;
    let createdDate = { from: projectCreatedFrom, to: projectCreatedTo };
    if (projectCreatedFrom && projectCreatedTo) {
      filtersList.unshift({
        id: "createdDate",
        label: `From: ${createdDate.from.getDate()}/${createdDate.from.getMonth() +
          1}/${createdDate.from.getFullYear()} - To: ${createdDate.to.getDate()}/${createdDate.to.getMonth() +
          1}/${createdDate.to.getFullYear()}`,
        type: "Created Date",
        projectCreatedFrom: new Date(this.state.projectCreatedFrom).getTime(),
        projectCreatedTo: new Date(this.state.projectCreatedTo).getTime(),
        optionName: "createdDate",
        value: {
          from: new Date(projectCreatedFrom).getTime(),
          to: new Date(projectCreatedTo).getTime()
        }
      });
      date.createdDate = createdDate;
    }
    let temp = uniqBy(filtersList, "id");
    this.setState({
      filtersList: temp
    });
  };

  validateFiltersOfCost = () => {
    let { projectCostTo, projectCostFrom, filtersList } = this.state;
    let filter = null;
    let projectCost = { from: projectCostTo, to: projectCostFrom };
    if (projectCostFrom && projectCostTo) {
      filtersList.unshift({
        id: "projectCost",
        label: `From: ${projectCost.from} - To: ${projectCost.to}`,
        type: "Project Cost",
        projectCostFrom: projectCostFrom,
        projectCostTo: projectCostTo,
        value: {
          from: projectCostTo,
          to: projectCostFrom
        },
        optionName: "projectCost"
      });
    }
    let temp = uniqBy(filtersList, "id");
    this.setState({
      filtersList: temp
    });
  };

  onClickingSchemeDropDown() {
    const { schemesList } = this.props;
    const schemesListOption = [];
    schemesList &&
      schemesList.data &&
      schemesList.data.map(schemesList => {
        schemesListOption.push({
          name: "projectScheme",
          label: schemesList.name,
          value: schemesList.id,
          optionName: "projectScheme"
        });
      });
    return schemesListOption;
  }

  onClickingLocationDropDown() {
    const { statesListData } = this.props;
    const statesListOption = [];
    statesListData &&
      statesListData.data &&
      statesListData.data.map(statesListData => {
        statesListOption.push({
          name: "projectLocation",
          label: statesListData.name,
          value: statesListData.id,
          optionName: "location"
        });
      });
    return statesListOption;
  }

  onClickingImplementationModeDropDown() {
    const { implementationModesList } = this.props;
    const implementationModeListOption = [];
    implementationModesList &&
      implementationModesList.data &&
      implementationModesList.data.implementationModeList.map(
        implementationModesList => {
          implementationModeListOption.push({
            name: "implementationMode",
            label: this.implementationModeTransformer[implementationModesList],
            value: implementationModesList,
            optionName: "implementationMode"
          });
        }
      );
    return implementationModeListOption;
  }

  onClickingDistrictDropDown() {
    const { ddByParentIdsList } = this.props;
    const districtOption = [];
    ddByParentIdsList &&
      ddByParentIdsList.map(district => {
        districtOption.push({
          name: "issueDistrict",
          label: district.name,
          value: district.id,
          optionName: "districtDepartments"
        });
      });
    return districtOption;
  }

  onClickingStatusDropDown() {
    const { projectStatusList } = this.props;
    const statusListOption = [];
    projectStatusList &&
      projectStatusList.data &&
      projectStatusList.data.statuses.map(statusList => {
        statusListOption.push({
          name: "projectStatus",
          label: replaceCharacterWith(statusList, "_", " ") || statusList,
          value: statusList,
          optionName: "projectStatus"
        });
      });
    return statusListOption;
  }

  onClickofApplyAllButton = () => {
    const {
      sponsoringMinistry,
      projectClassification,
      projectSector,
      implementationMode,
      projectLocation,
      projectScheme,
      projectStatus,
      projectCostFrom,
      projectCostTo,
      projectCreatedFrom,
      projectCreatedTo,
      openModal,
      multiStateProject,
      selectedMonitoringId,
      issueDistrict,
      previousFilterCount,
      currentFilterCount
    } = this.state;
    const { onOpenOfModal } = this.props;

    function filterNullUndefined(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([key, value]) =>
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0)
        )
      );
    }

    const createFilterArray = (sourceArray, targetType) => {
      return sourceArray ? sourceArray.map(item => parseInt(item.value)) : [];
    };

    let sponsoringMinistryFilter = createFilterArray(sponsoringMinistry);
    let multiStateProjectFilter = multiStateProject
      ? multiStateProject.length > 1
        ? "All"
        : multiStateProject[0].value
      : "";

    let schemeFilter = createFilterArray(projectScheme, "parseInt");
    let locationFilter = createFilterArray(projectLocation, "parseInt");
    let implementationModeFilter = implementationMode
      ? implementationMode.map(item => item.value)
      : [];
    let issueDistrictFilter = createFilterArray(issueDistrict, "parseInt");
    let statusFilter = projectStatus
      ? projectStatus.map(item => item.value)
      : [];

    let monitoringFilter = selectedMonitoringId
      ? selectedMonitoringId.length > 1
        ? "All"
        : selectedMonitoringId[0].value
      : "";

    var appliedFilters = filterNullUndefined({
      sponsoringMinistry: sponsoringMinistry ? sponsoringMinistryFilter : null,
      projectClassification: projectClassification
        ? [projectClassification]
        : null,
      sector: projectSector ? [parseInt(projectSector)] : null,
      implementationMode: implementationMode ? implementationModeFilter : null,
      multiStateProject: multiStateProject ? multiStateProjectFilter : null,
      location: projectLocation ? locationFilter : null,
      projectScheme: projectScheme ? schemeFilter : null,
      districtDepartments: issueDistrict ? issueDistrictFilter : null,
      projectStatus: projectStatus ? statusFilter : null,
      projectCost:
        projectCostFrom && projectCostTo
          ? [{ from: projectCostTo, to: projectCostFrom }]
          : null,
      createdDate:
        projectCreatedFrom && projectCreatedTo
          ? {
              from: new Date(projectCreatedFrom).getTime(),
              to: new Date(projectCreatedTo).getTime()
            }
          : null,
      monitoring: selectedMonitoringId ? monitoringFilter : null
    });
    this.props.fetchProjectReport(appliedFilters);
    this.validateFiltersOfProjectDates();
    this.validateFiltersOfCost();
    const appliedFilterList = this.onApplyingFilters();
    const newList = [...appliedFilterList, ...this.state.filtersList];
    const uniqueNewList = Array.from(new Set(newList.map(JSON.stringify))).map(
      JSON.parse
    );
    const filters = setLocalstorage("projectSummaryFilters", uniqueNewList);
    this.setState({ currentFilterCount: uniqueNewList.length });
    this.setState({ openModal: !openModal });
    onOpenOfModal(
      openModal,
      this.state.previousFilterCount,
      uniqueNewList.length
    );
  };

  clearAllFilledDataInformation = () => {
    const { inceptionDate } = this.state;
    this.setState({
      projectCreatedFrom: "",
      projectCreatedTo: "",
      sponsoringMinistry: "",
      multiStateProject: "",
      implementationMode: "",
      projectLocation: "",
      projectScheme: "",
      projectStatus: "",
      projectCostTo: "",
      projectCostFrom: "",
      issueDistrict: "",
      selectedMonitoringId: "",
      inceptionDate: false
    });
  };

  onApplyingFilters = () => {
    const {
      sponsoringMinistry,
      projectScheme,
      projectStatus,
      implementationMode,
      multiStateProject,
      selectedMonitoringId,
      issueDistrict,
      projectLocation
    } = this.state;
    let results = [];
    let filters = [];
    sponsoringMinistry && filters.push(...sponsoringMinistry);
    projectScheme && filters.push(...projectScheme);
    projectStatus && filters.push(...projectStatus);
    implementationMode && filters.push(...implementationMode);
    projectLocation && filters.push(...projectLocation);
    multiStateProject && filters.push(...multiStateProject);
    selectedMonitoringId && filters.push(...selectedMonitoringId);
    issueDistrict && filters.push(...issueDistrict);
    results.push(filters);
    return filters;
  };

  render() {
    const {
      projectCreatedFrom,
      projectCreatedTo,
      sponsoringMinistryList,
      sponsoringMinistry,
      implementationMode,
      projectLocation,
      projectScheme,
      projectStatus,
      projectCostTo,
      projectCostFrom,
      openModal,
      inceptionDate,
      multiStateProject,
      issueDistrict,
      selectedMonitoringId
    } = this.state;
    const {
      onProjectCraeatedDateChange,
      onProjectCraeatedFromDateChange,
      onClickOfCloseButton,
      clearAllFilledDataInformation,
      onClickofApplyAllButton,
      onInputChange,
      onInceptionDateChecked
    } = this;
    const sponsoringMinistryOptions = [];
    sponsoringMinistryList.map(sponsoringMinistry => {
      sponsoringMinistryOptions.push({
        name: "sponsoringMinistry",
        label: sponsoringMinistry.name,
        value: sponsoringMinistry.id,
        optionName: "sponsoringMinistry"
      });
    });

    const Option = props => {
      return (
        <div>
          <components.Option {...props}>
            <div class="checkbox-container-options">
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />{" "}
              <label>{props.label}</label>
            </div>
          </components.Option>
        </div>
      );
    };

    const selectStyle = {
      control: (baseStyles, state) => ({
        ...baseStyles,
        color: "#000000",
        fontFamily: "mpsb",
        fontSize: "16px",
        lineHeight: "22px"
      }),
      option: (baseStyles, state) => ({
        ...baseStyles,
        backgroundColor: "white",
        fontSize: "14px",
        lineHeight: "18px",
        color: "#525252"
      })
    };

    return (
      <>
        <Modal
          show={openModal}
          onHide={onClickOfCloseButton}
          className="issue-summary-modal project-summary-modal"
          centered={true}
          dialogClassName="box-shadow-none"
        >
          <Modal.Body>
            <div className="issue-summary-modal-body">
              <div className="input-fields d-flex inception-date-inputfield">
                <div
                  className={`input-field-left created-date ${
                    inceptionDate ? "date-field-disable" : ""
                  }`}
                >
                  <DatePickerField
                    label={"Created From"}
                    formData={projectCreatedFrom}
                    onChange={onProjectCraeatedDateChange}
                    isInceptionDate={inceptionDate}
                  />
                  <Form.Group
                    className="checkbox inception-date"
                    controlId="formBasicCheckbox"
                  >
                    <Form.Check
                      className="d-flex align-items-center"
                      type="checkbox"
                      label="Inception Date"
                      onClick={() => {
                        this.setState(
                          { inceptionDate: !inceptionDate },
                          onInceptionDateChecked
                        );
                      }}
                      checked={inceptionDate}
                    />
                  </Form.Group>
                </div>
                <div className="input-field-right created-to-date">
                  <DatePickerField
                    label={"Created To"}
                    formData={projectCreatedTo}
                    onChange={onProjectCraeatedFromDateChange}
                  />
                </div>
              </div>
              <div className="input-fields d-flex mt-3">
                <div className="input-field-left select-field">
                  <Select
                    placeholder="-Select Sponsoring Ministry-"
                    options={sponsoringMinistryOptions}
                    value={sponsoringMinistry}
                    onChange={event =>
                      this.onSelectChange(event, "sponsoringMinistry")
                    }
                    isMulti={true}
                    styles={selectStyle}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="input-field-right select-field">
                  <Select
                    placeholder="-Select Multi State Projects-"
                    options={MULTI_STATE_PROJECT}
                    value={multiStateProject}
                    onChange={event =>
                      this.onSelectChange(event, "multiStateProject")
                    }
                    styles={selectStyle}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    isClearable={true}
                    classNamePrefix="react-select"
                    isMulti
                  />
                </div>
              </div>
              <div className="input-fields d-flex mt-4">
                <div className="input-field-left select-field">
                  <Select
                    placeholder="-Select Scheme-"
                    options={this.onClickingSchemeDropDown()}
                    value={projectScheme}
                    onChange={event =>
                      this.onSelectChange(event, "projectScheme")
                    }
                    isMulti={true}
                    styles={selectStyle}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="input-field-right select-field">
                  <Select
                    placeholder="-Select Location-"
                    options={this.onClickingLocationDropDown()}
                    value={projectLocation}
                    onChange={event =>
                      this.onSelectChange(event, "projectLocation")
                    }
                    isMulti={true}
                    styles={selectStyle}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="input-fields d-flex mt-4">
                <div className="input-field-left select-field">
                  <Select
                    placeholder="-Select Implementation Mode-"
                    options={this.onClickingImplementationModeDropDown()}
                    value={implementationMode}
                    onChange={event =>
                      this.onSelectChange(event, "implementationMode")
                    }
                    isMulti={true}
                    styles={selectStyle}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="input-field-right select-field">
                  <Select
                    placeholder="-Resolved Issues Status-"
                    options={SELECT_MONITORING_OPTION}
                    value={selectedMonitoringId}
                    onChange={event =>
                      this.onSelectChange(event, "selectedMonitoringId")
                    }
                    styles={selectStyle}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    isClearable={true}
                    classNamePrefix="react-select"
                    isMulti={true}
                  />
                </div>
              </div>
              <div className="input-fields d-flex mt-4">
                <div className="input-field-left select-field">
                  <Select
                    placeholder="-Select Project Status-"
                    options={this.onClickingStatusDropDown()}
                    value={projectStatus}
                    onChange={event =>
                      this.onSelectChange(event, "projectStatus")
                    }
                    styles={selectStyle}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    isClearable={true}
                    classNamePrefix="react-select"
                    isMulti={true}
                  />
                </div>
                <div className="input-field-right select-field">
                  <Select
                    placeholder="-Select District/Department-"
                    options={this.onClickingDistrictDropDown()}
                    value={issueDistrict}
                    onChange={event =>
                      this.onSelectChange(event, "issueDistrict")
                    }
                    isMulti={true}
                    styles={selectStyle}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option }}
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="input-fields d-flex mt-4">
                <div className="input-field-left">
                  <NumberField
                    name="projectCostTo"
                    label={"Cost From"}
                    placeholder={"₹0"}
                    formData={projectCostTo}
                    onChange={onInputChange}
                    style={{ fontSize: "14px", lineHeight: "22px" }}
                  />
                </div>
                <div className="input-field-right">
                  <NumberField
                    name="projectCostFrom"
                    label={"Cost To"}
                    placeholder={"₹0"}
                    formData={projectCostFrom}
                    onChange={onInputChange}
                    style={{ fontSize: "14px", lineHeight: "22px" }}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              size="sm"
              onClick={clearAllFilledDataInformation}
              className="btn-grey"
              style={{ marginRight: "8px" }}
            >
              Clear All
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={onClickofApplyAllButton}
              className="btn-orange"
              style={{ width: "143px", marginLeft: "8px" }}
            >
              Apply
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    sectorsList: state.misReducer.sectorsList,
    implementationModesList: state.misReducer.implementationModesList,
    statesListData: state.misReducer.statesList,
    schemesList: state.misReducer.schemesList,
    projectStatusList: state.misReducer.projectStatusList,
    ddByParentIdsList: state.misReducer.ddByParentIdsList
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getRecipientMinistryStateAction,
      fetchProjectReport,
      fetchIssueSubCategories
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProjectSummarySearchModal)
);
